import {emailSignUp} from '@/services/cta';

export default {
  state: {},
  mutations: {},
  actions: {
    emailSignUp(context, email) {
      return emailSignUp(email).catch(e => {
        // Transform error into plain javascript result with success: true etc
        return {success: false, ...e.response.data};
      });
    }
  },
  getters: {}
}



// WEBPACK FOOTER //
// ./src/store/cta.js